import React, { useState } from "react";
import { Grid, Typography, Button } from "@mui/material";
import LandingRegPageWithEmail from "./LandingRegPageWithEmail";
import { Divider } from "@mui/material";
import LabelButton from "../../components/reusable-components/buttons/LabelButton";
import { useBannerDispatch } from "../../contexts/BannerContext";

export default function CustomRegisterNotInvitePage({
  inputEmail,
  handleInputEmail,
  validate,
  errors,
  handleContinueWithEmail,
  emailResponseError,
  botCheckPassed,
  setBotCheckPassed,
  invitationToken,
  handleGoogleRegister,
  newRegistrationFromCPS,
  newRegWithActiveInvite,
  accountName,
}) {
  const [isSendingInvite, setIsSendingInvite] = useState(false);
  const [disableInviteButton, setDisableInviteButton] = useState(false);
  const bannerDispatch = useBannerDispatch();

  const handleResendInvite = async () => {
    setIsSendingInvite(true);

    const res = await fetch("/auth/register/resendinvite", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: inputEmail, accountName: accountName }),
    });

    if (res.ok) {
      setIsSendingInvite(false);
      setDisableInviteButton(true);
      bannerDispatch({
        type: "changeBannerState",
        payload: {
          mainText: "Resending invite successful",
          subText:
            "Please check your email to use the new invitation link to register.",
          tallBanner: true,
          success: true,
        },
      });
      //set the invite button to disable for 10 minutes
      setTimeout(() => {
        setDisableInviteButton(false);
      }, 600000);
      return;
    } else {
      setIsSendingInvite(false);
      bannerDispatch({
        type: "changeBannerState",
        payload: {
          mainText: "Resending invite failed",
          subText:
            "An error occurred while sending the invitation. Please try again.",
          tallBanner: true,
          success: false,
        },
      });
      return;
    }
  };

  return (
    <>
      {newRegWithActiveInvite && (
        <>
          <Grid
            item
            sx={{
              width: "100%",
              height: "auto",
            }}>
            <Typography
              sx={{
                color: "var(--Blacks-500, #100C08)",
                fontFamily: "Lato",
                fontSize: 14,
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "21px",
              }}>
              You've been invited to join{" "}
              <span style={{ fontWeight: 700 }}>{accountName}</span>. We've sent
              an invitation link to{" "}
              <span style={{ fontWeight: 700 }}>{inputEmail}</span>
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              width: "100%",
              height: "60px",
              padding: "12px 20px",
              border: "1px solid var(--Neutrals-500, #E2E6E9)",
              borderRadius: "10px",
              marginBottom: "34px",
            }}>
            <Grid
              container
              direction="column"
              sx={{
                height: "100%",
                width: "100%",
                justifyContent: "space-between",
              }}>
              <Typography
                sx={{
                  color: "var(--Primary-900, #0B0926)",
                  fontFamily: "Lato",
                  fontSize: 14,
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "normal",
                }}>
                {accountName}
              </Typography>
              <Typography
                sx={{
                  color: "var(--Neutrals-900, #6F8090)",
                  fontFamily: "Lato",
                  fontSize: 10,
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "normal",
                }}>
                {inputEmail}
              </Typography>
            </Grid>
          </Grid>
        </>
      )}

      {/* google button */}
      <Grid
        item
        sx={{
          width: "100%",
          height: "auto",
        }}>
        <Grid
          container
          direction="column"
          sx={{
            width: "100%",
            height: "100%",
            justifyContent: "space-between",
          }}>
          <Grid
            item
            sx={{ width: "100%", height: "60px" }}
            className="start-with-google">
            <Button
              color="primary"
              fullWidth
              onClick={handleGoogleRegister}
              sx={{
                border: "2px solid #16124C",
                borderRadius: "6px",
                height: "100%",
              }}>
              <>
                <img
                  src="https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA"
                  alt="google"
                  style={{
                    height: "24px",
                    marginRight: "10px",
                  }}
                />
                <Typography
                  sx={{
                    color: "var(--Primary-500, #16124C)",
                    fontFamily: "Lato",
                    fontSize: 14,
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                    textTransform: "none",
                  }}>
                  Continue with Google
                </Typography>
              </>
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {!newRegistrationFromCPS && !newRegWithActiveInvite && (
        <LandingRegPageWithEmail
          email={inputEmail}
          handleInputEmail={handleInputEmail}
          validate={validate}
          errors={errors}
          handleContinueWithEmail={handleContinueWithEmail}
          emailResponseError={emailResponseError}
          botCheckPassed={botCheckPassed}
          setBotCheckPassed={setBotCheckPassed}
          invitationToken={invitationToken}
        />
      )}
      {newRegWithActiveInvite && (
        <>
          <Divider
            sx={{
              width: "100%",
              color: "var(--Neutrals-900, #6F8090)",
              fontFamily: "Lato",
              fontSize: 14,
              fontWeight: 400,
              "&::before, &::after": {
                borderColor: "var(--Neutrals-900, #6F8090)",
                borderTopWidth: "1px",
              },
            }}>
            Or
          </Divider>
          <Grid
            item
            sx={{
              width: "100%",
              height: "60px",
            }}>
            <LabelButton
              type="primary"
              variant="contained"
              text={isSendingInvite ? "Sending Invite.." : "Resend Invite"}
              function={handleResendInvite}
              disabled={isSendingInvite || disableInviteButton}
              disableButtonStyle={{
                border: "none",
                background: "var(--Primary-500, #16124C)",
                color: "var(--Neutrals-100, #FFF)",
                opacity: 0.25,
              }}
            />
          </Grid>
        </>
      )}
    </>
  );
}
